import { render, staticRenderFns } from "./boot-statistic.vue?vue&type=template&id=15915085&scoped=true"
import script from "./boot-statistic.vue?vue&type=script&lang=js"
export * from "./boot-statistic.vue?vue&type=script&lang=js"
import style0 from "./boot-statistic.vue?vue&type=style&index=0&id=15915085&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15915085",
  null
  
)

export default component.exports